// Dutch translation file
import { Translations } from '../i18n/en'

const progress_bar = {
  campaign_details: 'Campagnedetails',
  data_upload: 'Gegevens uploaden',
  questionnaire: 'Vragen',
  referral_questionnaire: 'Vragen voor vrienden',
  incentive: 'Cadeau',
  referral_incentive: 'Cadeau voor een vriend',
  compose_creative: 'Creatie toevoegen',
  emails: 'Emails',
  happiness_check: 'Happiness check',
  finalise: 'Afronden',
}

const campaign_details = {
  customer: 'Klant',
  select_customer: 'Selecteer klant',
  campaign_group: 'Campagnegroep',
  select_group: 'Selecteer groep',
  no_group: 'Geen groep',
  select_customer_first: 'Selecteer eerst een klant',
  details: 'Details',
  campaign_name: 'Campagnenaam',
  company_name: 'Bedrijfsnaam',
  start_date: 'Begindatum',
  end_date: 'Einddatum',
  postage_preferences: 'Post voorkeuren',
  sender_address: 'Afzenderadres',
  referral_campaign: 'Stuur een vriend',
  include_referral:
    'Wilt u de mogelijkheid bieden cadeaus aan vrienden te geven?',
  birthday_campaign: 'Verjaardagcampagne',
  include_birthday:
    'Met een verjaardagcampagne kunt u cadeaus versturen voor de verjaardag van uw klant',
  type_of_campaign: 'Campagnetype',
  offline: 'Offline',
  offline_description: 'Ansichtkaart of Flyer campagne',
  online: 'Online',
  online_description: 'E-mail campagne',
  email_address: 'E-mailadres of een URL',
  email_address_label:
    'Het adres zal verschijnen op de ansichtkaart in geval van een offline campagne',
  privacy_link: 'Privacyverklaring Link',
  privacy_link_description:
    'De link naar jouw privacy statement. Deze wordt getoond aan de deelnemers.',
  send_email_date: 'Moment waarop de email campagne verzonden wordt',
}

const languages = {
  en: 'Switch to English',
  nl: 'Switch to Dutch',
}

const navigation = {
  create_campaign: 'Maak campagne',
  dashboard: 'Dashboard',
  campaign_list: 'Campagne overzicht',
  agenda: 'Agenda',
  log_out: 'Uitloggen',
  admin: 'Admin',
  hi: 'Hoi',
  action_panel: 'Acties',
  get_started: 'Om aan de slag te gaan, selecteert u eenvoudig',
  get_started_2: 'een van deze acties',
  incentives: 'Cadeaus',
  sku_builder: 'SKU list',
  search_placeholder: 'Search for SKU or Incentive',
}

const campaign_list = {
  done: 'Klaar',
  in_progress: 'In uitvoering',
  upcoming: 'Komende',
  draft: 'Concept',
  customer: 'CUSTOMER',
  campaign_list: 'Campagne overzicht',
  campaign_name: 'CAMPAGNENAAM',
  start_date: 'begindatum',
  end_date: 'EINDDATUM',
  status: 'STATUS',
  claimed_gifts: 'GECLAIMDE cadeaus',
  details: 'Details',
  edit: 'Bewerk',
  actions: 'Acties',
  campaign_data: 'CAMPAGNE DATA',
  duplicate: 'Kopieer',
  execute_failed_title: 'Kan campagne niet uitvoeren',
  open_campaign: 'Open campagne',
  // Pagination and filtering
  search_placeholder: 'Zoek campagnes...',
  filter_by_customer: 'Filter op klant',
  all_customers: 'Alle klanten',
  page_info: 'Pagina {{currentPage}} van {{totalPages}}',
  previous: 'Vorige',
  next: 'Volgende',
}

const questionnaire = {
  theme: 'Thema',
  select_theme: 'Door een thema te kiezen bepaal je de stijl van je campagne',
  referral_theme_preselected:
    'The theme of the campaign is set in the original questionnaire nl',
  questionnaire: 'Vragenlijst',
  select_questionnaire: 'Hieronder kunt u een set vragen kiezen en aanpassen',
  questionnaire_1: {
    name: 'Persoonlijk',
  },
  questionnaire_2: { name: 'Tevredenheid / interesse' },
  review_selected_questionnaire: 'Pas geselecteerde vragenlijst aan',
  referral_campaign: 'Send a friend campagne',
  referral_campaign_description:
    'Klanten kunnen de campagne eenvoudig delen met hun vrienden en contacten via onze send a friend functionaliteit.',
}

const validation_messages = {
  required: 'Dit veld is verplicht',
  Required: 'Dit veld is verplicht',
  invalid_date: 'Ongeldige datum',
  start_date_too_soon_offline: 'Startdatum moet minimaal over 21 dagen zijn',
  start_date_too_soon_online: 'Startdatum moet minimaal over 1 dag zijn',
  campaign_length_too_short: 'De campagne moet minimaal 1 dag lang zijn',
  campaign_end_date_in_the_past:
    'De einddatum van de campagne moet in de toekomst liggen',
  empty_incentive: 'Selecteer ten minste één item',
  invalid_number: 'Voer geldig nummer in',
  invalid_postcode: 'Ongeldige postcode',
  hex_color: 'Gebruik een hex-kleur van 6 tekens, bijvoorbeeld #1b6ad3',
  invalid_email: 'Ongeldige e-mailindeling',
  invalid_house_number: 'Ongeldig huisnummer',
  invalid_phone_number: 'Ongeldig telefoonnummer',
  invalid_url: 'Ongeldige URL',
  missing_picture: 'Upload een afbeelding om een nieuw cadeau toe te voegen',

  // Additional validation messages for all error types
  max_length: 'De waarde is te lang',
  min_length: 'De waarde is te kort',
  invalid_type: 'Ongeldig type',
  invalid_string: 'Ongeldige tekst',
  invalid_enum_value: 'Ongeldige selectie',
  invalid_arguments: 'Ongeldige argumenten',
  invalid_return_type: 'Ongeldig terugkeertype',
  invalid_union: 'Ongeldige combinatie',
  invalid_union_discriminator: 'Ongeldige discriminator',
  invalid_literal: 'Ongeldige waarde',
  too_big: 'De waarde is te groot',
  too_small: 'De waarde is te klein',
  custom: 'Validatiefout',
  invalid: 'Ongeldige invoer',
  not_found: 'Niet gevonden',
  not_multiple_of: 'Moet een veelvoud zijn van {{multipleOf}}',
  invalid_format: 'Ongeldig formaat',
  max_date: 'Datum mag niet later zijn dan {{maxDate}}',
  min_date: 'Datum mag niet eerder zijn dan {{minDate}}',
  not_optional: 'Dit veld is verplicht',
  unrecognized_keys: 'Niet-herkende sleutels',
  invalid_intersection_types: 'Ongeldige intersectietypes',
  invalid_check: 'Ongeldige controle',
}

const end_users = {
  end_users: 'Eindgebruiker',
  preview: 'Voorbeeld',
  data_rows: 'Totaal aantal eindgebruikers:',
  data_check: 'Gegevens controleren',
  data_upload: 'Gegevens uploaden',
  download_example: 'voorbeeldbestand',
  table_header: {
    first_name: 'Voornaam',
    middle: 'Tussenvoegsel',
    last_name: 'Achternaam',
    company: 'Bedrijfsnaam',
    email: 'E-mail',
    phone_number: 'Telefoonnummer',
    postal_code: 'Postcode',
    city: 'Plaats',
    street_name: 'Straatnaam',
    house_number: 'Huisnummer',
    country: 'Land',
    birthday: 'Geboortedag',
    sku: 'SKU',
    digital_code: 'Digital Code',
    postnl_code: 'Dutch post Code nl',
    reference_code: 'Reference Code nl',
  },
  map_field_placeholder: '[Kolomnaam]',
  missing_data: 'Het lijkt erop dat er gegevens ontbreken',
  missing_data_text:
    'De volgende gegevens ontbreken in de upload. Upload een nieuw bestand met de ontbrekende gegevens.',
  upload: 'UPLOADEN',
  missing: 'MISSEND',
  errors: {
    birthday: 'Geboortedag yyyy-MM-dd or MM/dd/yyyy',
    firstName: 'Voornaam',
    middle: 'Tussenvoegsel',
    lastName: 'Achternaam',
    email: 'Email',
    email_invalid: 'Ongeldig e-mailadres',
    email_duplicate: 'Dubbel e-mailadres',
    sku: 'SKU',
    postnlCode: 'Dutch post code nl',
    referenceCode: 'Reference Code nl',
    postcode: 'Postcode',
    postalCode: 'Postcode',
  },
  ok: 'OK ik snap het',
  missing_sku_codes:
    'De onderstaande SKU-codes ontbreken in de bestaande SKU-lijst',
  user_profile: {
    happiness_check_header: 'Happiness Check Antwoorden',
    incentive_header: 'Cadeau Details',
    incentive_name_label: 'Cadeau Naam',
    events_header: 'Gebeurtenissen',
    allow_contact_consent_label: 'Contact Toestemming Toestaan',
    optional_data_header: 'Optionele Gegevens',
    mapping_header: 'Mapping Gegevens',
    questionnaire_answers_header: 'Vragenlijst Antwoorden',
    account_info_header: 'Accountinformatie',
    personal_details_header: 'Persoonlijke Details',
    full_name_label: 'Volledige Naam',
    id_label: 'ID',
    email_label: 'E-mail',
    address_label: 'Adres',
    campaigns_header: 'Campagnes',
    phone_label: 'Telefoon',
    birthday_label: 'Verjaardag',
    digital_code_label: 'Digitale Code',
    privacy_link_accepted_label: 'Privacy Link Geaccepteerd',
    years_old: '{{age}} jaar oud',
  },
  title: 'Title',
  add_new: 'Add new',
  edit_user: 'Edit user',
  edit: 'Edit',
  delete: 'Delete',
  name: 'Name',
  email: 'Email',
  phone: 'Phone',
  address: 'Address',
  unique_code: 'Unique code',
  actions: 'Actions',
  no_users: 'No users',
  first_name: 'First name',
  last_name: 'Last name',
  select_sku: 'SKU',
  sku: 'SKU',
  confirm_delete: 'Are you sure you want to delete this test user?',
  clear_answers: 'Are you sure you want to clear the answers for this user?',
}

const file_upload = {
  a: 'een',
  or: 'of',
  upload_file: 'Upload',
  drag_and_drop: 'of sleep',
  file: 'bestand',
  remove: 'Verwijderen',
}

const optional_question = {
  title: 'Nieuwe vraag toevoegen',
  description: 'U kunt hier uw eigen vraag toevoegen',
  question: 'Vraag',
  type: 'Type',
  cancel: 'Annuleren',
  add_question: 'Vraag toevoegen',
  reverse_changes: 'Wijzigingen ongedaan maken',
  question_placeholder:
    'Hoe waarschijnlijk is het dat je ons zou aanbevelen aan een vriend of collega?',
  type_placeholder: 'Open Vraag',
}
const compose_creative = {
  title: 'Creatie toevoegen',
  sub_title: 'Campagnetype',
  offline: 'Offline',
  offline_post_card: 'Ansichtkaart campagne',
  online: 'Online',
  online_email: 'Email campagne',
  postcard: 'Ansichtkaart',
  postcard_description: 'Ansichtkaart campagne',
  flyer: 'Flyer',
  flyer_description: 'Flyer campagne',
}

const incentives = {
  title: 'Cadeaus',
  referral_incentives_title: 'Vrienden',
  select: 'Selecteer',
  selected: 'Geselecteerd',
  types: {
    unique_digital: 'Unieke digitale cadeaucode',
    universal_digital: 'Universele digitale cadeaucode',
    physical: 'Fysieke cadeaus',
    intersolve: 'Intersolve integration',
    gift_group: 'Cadeaugroep',
  },
  sku_code: 'SKU Code',
  digital_code: 'Universele digitale cadeaucode',
}

const add_incentive = {
  add_incentive: 'Cadeau toevoegen',
  upload_here: 'U kunt uw eigen cadeau hier uploaden',
  upload_image_hint:
    'Aanbevolen: 1200 × 600 px (2:1 liggend), JPG of PNG onder 1 MB.',
  name: 'Naam van het cadeau',
  price: 'Prijs',
  description: 'Omschrijving',
  category: 'Categorie',
  type: 'Type',
  customer: 'Klant',
  download_example: 'Download voorbeeldbestand',
  upload_voucher_code_file: 'Upload waardeboncodes',
  shop: 'Winkel',
  gift_group_items: 'Cadeaugroep items',
  gift_group_items_required: 'Selecteer minimaal één cadeaugroep-item',
  select_customer_first: 'Selecteer eerst een klant',
  no_gift_group_items:
    'Geen Intersolve- of fysieke items beschikbaar voor deze klant',
  locked_after_claim:
    'Vergrendeld — deze incentive is al geclaimd door een eindgebruiker.',
}

const offline = {
  title_design_front: 'Ansichtkaart ontwerp voorkant',
  content_design_front:
    'Hier kunt u uw eigen ontwerp van de ansichtkaart uploaden.',
  post_card_design: 'Ansichtkaart ontwerp',
  title_design_back: 'Ansichtkaart ontwerp achterkant',
  content_design_back:
    'Hier kun je je eigen logo uploaden en tekst aan de kaart toevoegen',
  logo: 'Logo',
  logo_hint:
    "Aanbevolen: 450 x 200 px voor horizontale logo's, 200 x 300 px voor verticale logo's (PNG of JPG).",
  text_on_the_back: 'Tekst op de achterkant van de kaart',
  landing_text_back: 'Tekst op de landingspagina',
  heading: 'Titel',
  add_text: 'Tekst toevoegen',
  preview: 'Voorbeeld',
  special_gift_awaited: 'Speciaal een cadeau voor u!',
  add_text_placeholder: 'Claim uw cadeau!',
  form_of_address: 'Aanspreekvorm',
  card_design: 'Kaart ontwerp',
  info_card: {
    card_requirements: 'Kaartvereisten',
    post_card_design: 'Ansichtkaart ontwerp',
    safety_margin: 'Veiligheidsmarge',
    cutting_margin: 'Snijmarge',
    yellow: 'Geel',
    red: 'Rood',
    safety_size: ': 148 x 210mm',
    cutting_size: ': 154 x 216mm',
    safety_margin_description:
      "De veiligheidsmarge (gele rand) geeft aan hoe ver belangrijke elementen, zoals teksten en logo's, van de rand van uw ontwerp moeten blijven. Hiermee voorkomt u dat de tekst gedeeltelijk wordt afgesneden of op de rand van uw drukwerk komt te staan.",
    cutting_margin_description:
      'Snijmarge (bleed) is de marge die je in je ontwerp aanhoudt om (witte) snijlijnen aan de rand van je drukwerk te voorkomen. Wij vragen een snijmarge van 3 mm per zijde.',
    tip: 'Tip',
    tip_description:
      'Laat je achtergrond doorlopen tot en met de rode rand (de afloop), hier zit namelijk minimale speling tijdens het knippen. Dit voorkomt witte randen na het uitsnijden en zorgt ervoor dat de achtergrond aan alle kanten mooi doorloopt.',
  },
}

const confirmation = {
  title: 'Uw Campagne is helemaal klaar!',
  description: 'U vindt en beheert al uw campagnes in het campagne overzicht',
  go_to_campaign_list: 'Ga naar campagne overzicht​',
}

const happiness_check = {
  module: 'Reviewscore',
  include: 'Neem de reviewscore op',
  really_negative: 'Zeer slecht',
  negative: 'Matig',
  alright: 'Gemiddeld',
  positive: 'Goed',
  really_positive: 'Uitstekend',
}
const online = {
  email_title: 'E-mail ontwerp',
  redeem_gift: 'Cadeau inwisselen',
  email_text: 'E-mail Tekst',
  template_image_hint:
    'Aanbevolen: 1200 × 600 px (2:1 liggend), JPG of PNG onder 1 MB.',
}

const print_files_download = {
  modal_title: 'beveiligde bestandsdownload',
  modal_description: `Dit bestand is beveiligd met een wachtwoord om de grootst mogelijke veiligheid te garanderen. Voer hieronder het juiste wachtwoord in om toegang te krijgen. Ga er zorgvuldig mee om en deel het alleen met geautoriseerde ontvangers.`,
  download: 'Download bestand',
  copied: 'Gekopieerd naar het klembord',
}

const incentive_categories = {
  personal_care: 'Persoonlijke verzorging',
  home: 'Huis',
  other: 'Overige',
  foods_and_drinks: 'Eten & Drinken',
}

const dashboard_labels = {
  dashboard: 'Dashboard',
  general_campaign: 'Algemeen',
  referral_campaign: 'Vrienden',
  campaign_overview: 'Campagne overzicht',
  campaign_performance: 'Campagneprestaties',
  requested_incentives: 'Aangevraagde cadeaus',
  by_share: 'аandeel',
  by_type: 'per type',
  over_time: 'in de loop van de tijd',
  since_the_beginning_of_the_campaign: 'sinds het begin van de campagne',
  happiness_check: 'Happiness Check',
  incentiveVoucherReserved: 'Cadeau vouchers gereserveerd',
  incentiveVoucherUsed: 'Cadeau vouchers gebruikt',
  incentiveVoucherExpired: 'Cadeau vouchers verlopen',
  incentive_code_used: 'Giftcards aangevraagd',
  view_customer_dashboards: 'Bekijk Klant Dashboards',
  overview: {
    campaign_reached: 'Totaal bereik',
    scanned_qr_codes: 'Gescande QR-codes',
    referral_link_opens: 'Aantal links gestuurd naar vrienden geopend',
    questionnaire_started: 'Vragenlijst gestart',
    questionnaire_completed: 'Vragenlijst voltooid',
    scanned_qr_codes_online: 'E-mail geopend',
    referral_link_opens_online: 'Referral Link Opens',
    questionnaire_started_online: 'Begonnen aan de flow',
    questionnaire_completed_online: 'Activatie voltooid',
    incentives_requested_online: 'Incentives Requested',
    incentives_requested: 'Cadeaus aangevraagd',
    incentiveVoucherReserved: 'Cadeau vouchers gereserveerd',
    incentiveVoucherUsed: 'Cadeau vouchers gebruikt',
    incentiveVoucherExpired: 'Cadeau vouchers verlopen',
  },
  performance_by_time: {
    general: {
      reached: 'Nr. QR-codes gescand / website bezoeken',
      incentiveRequested: 'Cadeaus aangevraagd',
      questionnaireStarted: 'Vragen gestart',
      questionnaireCompleted: 'Ingevulde vragen',
      incentiveVoucherReserved: 'Cadeau vouchers gereserveerd',
      incentiveVoucherUsed: 'Cadeau vouchers gebruikt',
      incentiveVoucherExpired: 'Cadeau vouchers verlopen',
      resetVoucherCode: 'Voucher code gereset',
    },
    referral: {
      reached: 'Aantal links gestuurd naar vrienden geopend',
      incentiveRequested: 'Cadeaus aangevraagd',
      questionnaireStarted: 'Vragen gestart',
      questionnaireCompleted: 'Ingevulde vragen',
      incentiveVoucherReserved: 'Cadeau vouchers gereserveerd',
      incentiveVoucherUsed: 'Cadeau vouchers gebruikt',
      incentiveVoucherExpired: 'Cadeau vouchers verlopen',
      resetVoucherCode: 'Voucher code gereset',
    },
  },
}

const tooltips = {
  generate_files: 'Genereer Bestanden',
  send_email: 'Stuur E-mail',
  download_user_data: 'Gebruikersgegevens Downloaden',
  download_creative: 'Drukbestanden downloaden',
}

const flyer = {
  title: 'Flyerontwerp',
  front: 'Voorkant',
  landing_page: 'Klantlandingspagina',
  landing_page_description:
    'Deze tekst verschijnt nadat je klant de QR-code heeft gescand.',
  main_campaign: 'Hoofdcampagne',
  heading: 'Titel',
  add_text: 'Voeg tekst toe',
  referral_campaign: 'Verwijzingscampagne',
  info_card: {
    flyer_requirements: 'Vereisten voor flyers',
    safety_margin: 'Veiligheidsmarge',
    cutting_margin: 'Snijmarge',
    yellow: 'Geel',
    red: 'Rood',
    safety_size: ': 210 x 148mm',
    cutting_size: ': 216 x 154mm',
  },
}

const campaign_categories = {
  title: 'Campagne Categorie',
  generic: 'Algemeen',
  birthday: 'Verjaardag',
  lottery: 'Loterij',
  generic_description:
    'Upload jouw databestand en creëer en verstuur jouw campagne',
  birthday_description:
    'Zorg dat je aandacht en waardering geeftop de verjaardagen van jouw doelgroep',
  lottery_description:
    'Haal de resultaten van de loterijtrekking open deel de prijzen met de winnaars',
}

const campaign_status = {
  active: 'In uitvoering',
  completed: 'Klaar',
}

const api_integration = {
  generic_header: 'Algemene Campagne',
  generic_text:
    'Selecteer alstublieft de datumreeks voor de klantgegevens die u wilt downloaden van de API.',
  lottery_text:
    'Selecteer alstublieft één of meerdere loterijinschrijvingsformulieren voor de klantgegevens die u wilt downloaden van de API.',
  lottery_header: 'Loterij Campagne',
  sync: 'Synchroniseer API-verbinding',
  generic_text_three_draws:
    'Selecteer de datum voor de klantgegevens die u wilt downloaden van de API.',
  purchases: 'Aankoopwinnaars',
  purchases_description:
    'Importeer winnaars op basis van aankoopgegevens voor uw geselecteerde datumperiode.',
  three_draws_and_prize: 'Drie Trekkingen & Prijs',
  three_draws_and_prize_description:
    'Importeer winnaars uit het drie-trekkingensysteem voor uw geselecteerde datum.',
}

const incentive_errors_modal = {
  delete_error_modal_title: 'De stimulans kan niet worden verwijderd',
  delete_incentive_item_is_used:
    'Cadeau item is in {{numberOfCampaigns}} gebruik',
  delete_incentive_with_used_voucher_codes:
    'Kan cadeau item niet verwijderen met gebruikte voucher codes',
  update_error_modal_title:
    'Dit geschenk is te zien in {{numberOfCampaigns}} campagnes',
  update_incentive_item_is_used:
    'De geselecteerde incentive is momenteel opgenomen in {{numberOfCampaigns}} campagnes. Als u deze wilt deactiveren, moet u de incentive uit de campagnes deselecteren',
}

const incentives_store = {
  title: 'Stimulansen',
  new_incentive: 'Nieuw cadeau',
  featured: 'Uitgelicht',
  product_info: 'Product informatie',
  price: 'Prijs',
  category: 'Categorie',
  description: 'Omschrijving',
  claimed: 'Geclaimd',
  disabled_active: 'Uitgeschakeld/Actief',
  pcs: 'per stuk',
  add_incentive: 'Nieuw cadeau toevoegen',
  active: 'Actief',
  status: 'Status',
  uploaded_files: 'Geüploade bestanden',
  add: 'Cadeau toevoegen',
  no_incentives: 'No incentives added for this customer yet.',
  please_add: 'Please add a new incentive',
  featured_tooltip: 'Uitgelicht in {{numberOfCampaigns}} campagnes',
  previous: 'Vorige',
  next: 'Volgende',
  all_customers: 'Alle eindgebruikers',
  all_categories: 'Alle categorieën',
  search_placeholder: 'Zoek cadeau',
  pagination_info:
    'Pagina {{currentPage}} van {{totalPages}} ({{startIndex}}-{{endIndex}} van de {{totalIncentives}} rijen getoond)',
}

const ec = {
  hello: 'Beste',
  dear: 'Beste',
  yes_button: 'Bekijk',
  back: 'Terug',
  next: 'Volgende',
  happiness_check_button: 'Geluk Controle',
  finish: 'Voltooien',
  home: {
    header: 'Gefeliciteerd!',
    text: 'Bekijk welke mooie prijs je hebt gewonnen.',
  },
  choose_incentive: {
    title: 'Speciaal voor jou!',
    sub_title: 'Veel plezier ermee.',
    header: 'KIES EEN CADEAU',
    header_lottery: 'JOUW PRIJS',
    validation: 'Kies een ander cadeau om verder te gaan',
    code_has_expired:
      'Uw vouchercode is verlopen, selecteer opnieuw een incentive',
  },
  happiness_check: {
    title: 'Laat ons weten over je ervaring',
    validation: 'Selecteer een optie om verder te gaan',
  },
  invite: {
    title: 'Er mag ook een cadeau aan een bekende gestuurd worden!',
    sub_title: 'Dit kan makkelijk door de onderstaande link te delen:',
    share_msg: 'Ik heb een cadeau voor jou',
    share_msg_heart_foundation:
      'Ik mocht als collectant van de Hartstichting een cadeautje uitzoeken. Jij mag dit ook! Wat kies jij uit?',
    share_msg_bmw:
      'Hi, Ik ga naar het preview event van de nieuwe BMW iX3. Wellicht is het ook voor jou interessant om die auto te bekijken. Je kunt je aanmelden via:',
    copy: 'Kopiëren',
    share: 'Delen',
    copied: 'Gekopieerd naar het klembord',
  },
  questionnaire: {
    title: 'Graag de benodigde gegevens hieronder invullen.',
    termsAndConditions: {
      text1: 'Ja, ik wil het graag ontvangen en ga er mee akkoord dat:',
      text2:
        'Mijn persoonsgegevens worden gebruikt voor het verwerken van mijn bestelling',
      text3: 'contact met mij mag opnemen ten behoeve van relevante acties',
      text4:
        'De persoonsgegevens zijn nodig om de bestelling te verwerken. Uiteraard worden de persoonsgegevens beschermd overeenkomstig de privacy policy van',
    },
  },
  success: {
    title: 'Hartelijk dank!',
    flyer_title: 'Hartelijk dank!',
    sub_title: 'Details zijn via de e-mail verstuurd.',
    title_with_happiness_check:
      'Klaar! Een persoonlijke mening wordt gewaardeerd.',
  },
  expired: {
    title: 'Oeps! De QR-code werkt niet meer.​',
    description:
      'Dit kan zijn doordat de campagne is afgelopen of omdat het cadeau al is geclaimd.',
    termsAndConditions: 'Terms and Conditions nl',
  },
}

const ec_flow_texts = {
  home: 'Home Page',
  incentive: 'Incentive Page',
  questionnaire: 'Questionnaire Page',
  invite: 'Invite Page',
  happiness_check: 'Happiness Check Page',
  success: 'Success Page',
  expired: 'Expired Page',
  sub_header:
    'Hieronder kunt u de tekst van de schermen voor uw eindklant kiezen en aanpassen',
  end_user: 'Eindgebruiker',
  referral: 'Vrienden',
  original_receiver: 'Originele ontvanger',
  invited: 'Ontvanger op uitnodiging',
  header: 'Koptekst',
  text: 'Tekst',
  termsAndConditions: 'Terms & Conditions tekst',
  termsAndConditionsEndUser: 'Terms & Conditions voor de eindgebruiker',
  termsAndConditionsReferral: 'Terms & Conditions voor doorverwijzers',
  termsAndConditionsMarketing: 'Terms & Conditions voor marketing',
  termsAndConditionsSummary: 'Terms & Conditions samenvatting',
  subject: 'Onderwerp',
  email_text: 'E-mailtekst',
  preview_link: 'Voorbeeld link',
  copy_link:
    'Kopieer de link om direct in uw browser/mobiele telefoon een voorbeeld te bekijken',
  get_link: 'Link ophalen',
  buttons_title: 'Knopteksten',
  buttons_help: 'Een tekst geldt voor elk scherm met deze knop.',
  button_view: 'Knop op het startscherm',
  button_next: 'Knop volgende',
  button_back: 'Knop terug',
  button_finish: 'Knop voltooien',
  button_copy: 'Knop kopiëren',
  button_share: 'Knop delen',
  button_copied: 'Melding na kopiëren',
  error_language: 'Taal van foutmeldingen',
  error_language_nl: 'Nederlands',
  error_language_en: 'English',
}

const emails = {
  header: 'E-mails',
  text: 'Hier kunt u de e-mailtekst wijzigen die uw eindklanten gaan ontvangen',
  add_email: 'Nieuwe e-mail toevoegen',
  emails_description:
    'Selecteer triggers om gepersonaliseerde e-mails voor de eindgebruikers te maken',
  edit_email: 'E-mail bewerken',
  toast: 'Deze trigger bestaat al',
  toast_description: 'Kies een andere trigger',
  successfully_selected_incentive: 'Cadeau succesvol geselecteerd',
  no_action_taken: 'Geen actie ondernomen',
  incomplete_online_process: 'Proces niet volledig afgerond',
  happiness_check: 'Tevredenheidscontrole',
  trigger: 'Trigger',
  trigger_description: 'Selecteer eerst een trigger',
  send_out: 'Te verzenden',
  rating_4: 'Bij waardering 4',
  rating_5: 'Bij waardering 5',
  rating: 'Waardering selecteren',
  select_rating: 'Selecteer een waardering',
  email_heading: 'E-mail titel',
  email_text: 'E-mail tekst',
  delete_email: 'E-mail verwijderen',
  emails: 'E-mails',
  email_sent_24h_after: 'Email verzend 24 uur na de trigger',
}

const sku_builder = {
  add_sku: 'Nieuwe SKU Code',
  update_sku: 'SKU bijwerken',
  sku_code: 'SKU Code',
  sku_list: 'SKU Lijst',
  no_sku: 'SKU bestaat niet',
  please_add_sku: 'Voeg SKU Code toe',
  incentives: 'Cadeau winkel',
  search_placeholder: 'Zoeken',
  add_sku_code: 'SKU Code toevoegen',
  update_sku_code: 'SKU Code bijwerken',
  featured_tooltip: 'Uitgelicht in {{numberOfIncentives}} cadeaus',
  assigned: 'Toegewezen',
  assign_incentive: 'Cadeau toewijzen',
  select_incentives: 'Selecteer cadeau',
  search_incentives: 'Zoek cadeaus...',
  no_incentives_found: 'Geen cadeaus gevonden',
  sku_exists: "SKU code '{{name}}' bestaat al",
}

const email_notification_texts = {
  noActionTaken: {
    header: 'Maak uw cadeaukeuze af',
    text: 'We zien dat u uw cadeau nog niet heeft geselecteerd. Mis deze kans niet!',
  },
  incompleteOnlineProcess: {
    header: 'Uw cadeaukeuze is niet afgerond',
    text: 'U bent er bijna! Rond uw cadeauselectie af om uw beloning te ontvangen.',
  },
  happinessCheck: {
    header: 'Deel uw positieve ervaring',
    text: 'Bedankt voor uw positieve feedback! We zouden het geweldig vinden als u uw ervaring wilt delen.',
  },
}

const questionnaire_builder = {
  picture_choice: 'Plaatjeskeuze',
  text_field: 'Tekstveld',
  long_text_field: 'Open vraag (lang antwoord)',
  radio_field: 'Gender',
  dynamic_radio_group: 'Meerkeuzevraag',
  dropdown_field: 'Dropdown meerkeuzevraag',
  date_field: 'Datum',
  toggle_field: 'Schakelaar',
  checkbox_field: 'Selectievakje',
  question: 'Vraag',
  required: 'Verplicht',
  drag_and_drop_question: 'Drag & drop',
  blocks_section: 'Sleep hier de vragen naartoe',
  blocks: 'Velden',
  delete_question: 'Verwijder vraag',
  min_length: 'Minimaal aantal tekens',
  max_length: 'Maximaal aantal tekens',
  add_new_question: 'Nieuwe vraag toevoegen',
  upload_pictures: 'Afbeeldingen uploaden',
  picture_upload_hint:
    'Gebruik voor het beste resultaat liggende afbeeldingen met een 2:1-verhouding (aanbevolen 1200 × 600 px), houd het onderwerp gecentreerd en gebruik dezelfde verhouding voor elke optie.',
  email: 'Email',
  questionnaire: 'Vragen',
  questionnaire_description:
    'Hieronder kunt u de tekst van de schermen voor uw eindklant kiezen en aanpassen',
  please_edit_fields: 'Maak deze vragen compleet voordat je verdergaat:',
  unnamed_field: 'Naamloze vraag',
  missing_options: 'voeg minstens één optie toe',
  missing_label: 'geef de vraag een titel',
}

const end_users_page = {
  title: 'Eindgebruikers',
}

const end_user_list = {
  filter_by_customer: 'Filter op Klant',
  search_label: 'Zoek Eindgebruikers',
  table_header_customer: 'Klant',
  table_header_name: 'Naam',
  table_header_email: 'E-mail',
  table_header_address: 'Adres',
  table_header_campaigns: 'Campagnes',
  table_header_actions: 'Acties',
  view_profile_action: 'Bekijk Profiel',
  pagination_page_info: 'Pagina {{currentPage}}',
  pagination_previous: 'Vorige',
  pagination_next: 'Volgende',
  search_placeholder: 'Zoeken...',
  all_customers: 'Alle Klanten',
}

const dashboard = {
  hello_user: 'Hallo, {{user}}!',
  view_campaign_dashboards: 'Bekijk campagne dashboards',
  last_month: 'Laatste maand',
  last_quarter: 'Laatste kwartaal',
  last_year: 'Laatste jaar',
  select_customer: 'Selecteer klant',
  all_customers: 'Alle Klanten',
  select_campaigns: 'Selecteer campagnes',
  all_campaigns: 'Alle Campagnes',
  question_context: 'Vraagtype',
  question_context_all: 'Alle Vragen',
  question_context_standard: 'Standaard',
  question_context_referral: 'Referral',
  total_reach_rate: 'Totaal bereikscore',
  reach_rate_subtitle:
    'Percentage eindgebruikers die de campagne hebben bereikt',
  data_enrichment_score: 'Data verrijkingsscore',
  enrichment_subtitle: 'Gemiddelde vragenlijst voltooiingspercentage',
  incentive_claim_rate: 'Incentive-claim percentage',
  incentive_subtitle: 'Percentage eindgebruikers die cadeaus hebben geclaimd',
  average_happiness_score: 'Gemiddelde happiness score',
  happiness_subtitle:
    'Gemiddelde beoordeling van eindgebruikers die feedback gaven',
  loading: 'Laden...',
  error: 'Fout',
  no_data_available: 'Geen gegevens beschikbaar',
  no_ratings_yet: 'Nog geen beoordelingen',
  responses: 'antwoorden',
  users: 'eindgebruikers',
  questions: 'vragen',
  engagement: {
    no_data_available:
      'Geen betrokkenheidsgegevens beschikbaar voor de geselecteerde periode.',
    title: 'Kansen voor dataverrijking',
    loading: 'Laden...',
    loading_data: 'Betrokkenheidsgegevens laden...',
    qr_email_opens: 'Open-rate',
    gift_selection: 'Cadeau geselecteerd',
    questions_optional: 'Vragen (optioneel)',
    started_questionnaire: 'Vragenlijst gestart',
    claimed_gift: 'Cadeau geclaimd',
    ratings_given: 'Beoordelingen gegeven',
    shared_referrals: 'Aantal referrals',
    quick_response: 'Snelle reactie',
    overall_score: 'Algemene betrokkenheidsscore',
    score_description:
      'Percentage van het totale publiek dat de volledige engagementfunnel heeft doorlopen en hun cadeau heeft geclaimd.',
    calculation_label: 'Berekening:',
    calculation_description: 'Cadeau geclaimd ÷ Totaal publiek',
    higher_score_label: 'Hogere score =',
    higher_score_description:
      'Meer gebruikers die de volledige journey voltooien',
    total_users: 'eindgebruikers totaal',
    of_users: 'van {{count}} eindgebruikers',
    average_engagement:
      'Gemiddeld neemt {{score}}% van uw doelgroep deel aan elke activiteit',
    score_low: 'Laag (0-25%)',
    score_good: 'Goed (26-50%)',
    score_great: 'Geweldig (51-75%)',
    score_excellent: 'Uitstekend (76%+)',
  },
  charts: {
    bar_chart_horizontal: 'Staafgrafiek - Horizontaal',
    horizontal_bar_description: 'Een horizontale staafgrafiek',
    trending_up: 'Stijging van 5,2% deze maand',
    visitors_last_months: 'Totaal aantal bezoekers van de laatste 6 maanden',
    yes_no_responses: 'Ja/Nee antwoorden',
    no_responses_yet: 'Nog geen antwoorden',
    respondents_selected_yes:
      '{{count}} van {{total}} personen antwoordden "Ja"',
    yes: 'Ja',
    no: 'Nee',
    total_responses: '{{count}} personen hebben geantwoord',
    email_responses_excluded:
      'E-mail antwoorden zijn uitgesloten van visualisatie',
    email_privacy_message:
      'E-mail antwoorden worden niet getoond om privacyredenen',
    responses_collected: '{{count}} antwoorden verzameld',
    recent_responses_last_3: 'Recente antwoorden (laatste 3)',
    recent_responses_last_5: 'Recente antwoorden (laatste 5)',
    recent_responses_showing:
      'Recente antwoorden (toont {{showing}} van {{total}} totaal)',
    submitted_on: 'Ingediend op {{date}}',
    gender_distribution: 'Geslachtsverdeling',
    people_answered_one: '{{count}} persoon heeft geantwoord',
    people_answered_other: '{{count}} personen hebben geantwoord',
    count: 'Aantal',
    desktop: 'Desktop',
    january: 'Januari',
    february: 'Februari',
    march: 'Maart',
    april: 'April',
    may: 'Mei',
    june: 'Juni',
    response_distribution: 'Antwoordverdeling',
    picture_choice_distribution: 'Plaatjeskeuze verdeling',
    legend: 'Legenda',
    other: 'Overig',
    ages: 'Leeftijdsverdeling in 10-jaars intervallen',
    ages_count:
      'Leeftijdsverdeling in 10-jaars intervallen ({{count}} personen hebben geantwoord)',
    multi_select_distribution: 'Multi-select verdeling',
    multi_select_distribution_count:
      '{{totalRespondents}} personen hebben geantwoord, {{totalSelections}} selecties in totaal',
    failed: 'Fout bij laden van grafiek: {{error}}',
    export_csv: 'Exporteer CSV',
  },
  risk_factors: {
    title: 'Risicofactoren',
    subtitle:
      "Interactieve analyse van gebruikersbetrokkenheidsrisico's over {{count}} totaal eindgebruikers",
    export_options: 'Export opties',
    export_csv: 'Exporteer CSV',
    export_dialog_title: 'Exporteer risicofactoren',
    select_risk_types: 'Selecteer risicotypes om te exporteren:',
    never_opened: 'Nooit geopend',
    low_satisfaction: 'Lage tevredenheid',
    non_responders: 'Geen reactie',
    safe_users: 'Veilige eindgebruikers',
    total_at_risk: 'Totaal risico',
    safe_users_count: '{{count}} van totaal eindgebruikers',
    no_risk_data:
      'Geen risicogegevens beschikbaar voor de geselecteerde periode.',
    count_label: 'Aantal:',
    percentage_label: 'Percentage:',
    selections: '{{count}} selecties',
    of_users: 'van {{count}} eindgebruikers',
    safe_users_desc: 'Eindgebruikers zonder geïdentificeerde risicofactoren',
    select_at_least_one:
      'Selecteer ten minste één risicotype om te exporteren.',
    auth_required: 'Authenticatie vereist. Log opnieuw in.',
    export_failed: 'Exporteren van CSV mislukt: {{error}}',
    empty_csv: 'Leeg CSV-antwoord',
    of_total_users: 'eindgebruikers',
  },
  top_incentives: {
    title: 'Top 6 incentives (% + voorraad))',
    description: 'Ontdek de topcadeaukeuzes van onze eindgebruikers.',
    error_loading: 'Fout bij laden van cadeaus',
    no_data_available:
      'Geen cadeauselectiegegevens beschikbaar voor de geselecteerde periode.',
    selections_count: 'Selecties: {{count}} ',
    of_total_users: 'Cadeau gekozen: {{count}}',
    voucher_codes:
      'Vouchers: {{used}} gebruikt, {{free}} beschikbaar ({{total}} totaal)',
    chosen_gifts_title: 'Gekozen in de cadeauportal',
    show_chosen_gifts: 'Toon de cadeaus die eindgebruikers kozen',
    hide_chosen_gifts: 'Verberg de cadeaus die eindgebruikers kozen',
    times_chosen: 'Gekozen: {{count}}',
    no_chosen_gifts:
      'In deze cadeaugroep is in de geselecteerde periode geen cadeau gekozen.',
  },
  campaign_questions: {
    title: 'Vragen',
    loading_summary: 'Samenvatting laden...',
    campaigns_label: 'Campagnes: {{count}}',
    avg_completion_label: 'Gem. Voltooiing: {{rate}}%',
    total_users_label: 'Totaal eindgebruikers: {{count}}',
    unable_to_load: 'Kan samenvattingsgegevens niet laden',
    loaded_questions: '{{loaded}} van {{total}} vragen weergegeven',
    select_header: 'Selecteer',
    question_header: 'Vraag',
    type_header: 'Type',
    customer_header: 'Klant',
    campaign_header: 'Campagne',
    status_header: 'Status',
    unknown_type: 'onbekend',
    scroll_for_more: 'Scroll voor meer',
    selected_analysis:
      'Geselecteerde Vragen Analyse ({{count}} vragen geselecteerd)',
    questions_selected: '{{count}} vragen',
    selected_questions: 'Geselecteerd: {{count}} vraag/vragen',
    questions_label: 'Vragen:',
    no_questions_found: 'Geen vragen gevonden',
    error_loading_questions: 'Fout: {{message}}',
    reset_selection: 'Selectie Resetten',
  },
}

const translation: Translations = {
  emails,
  ec_flow_texts,
  ec,
  locale: 'nl-NL',
  yes: 'Ja',
  no: 'Nee',
  na: 'N.v.t.',
  save_draft: 'Concept opslaan',
  next_step: 'Volgende stap',
  save_campaign: 'Campagne opslaan',
  language: 'Taal',
  calendar: 'Kalender',
  loading: 'Laden',
  create: 'Creëren',
  close: 'Sluit',
  details: 'Details',
  cancel: 'Annuleren',
  formal: 'Formeel',
  informal: 'Informeel',
  save_to_preview: 'Concept opslaan om de preview te zien',
  download_front_pdf: 'Download voorzijde als pdf',
  download_back_pdf: 'Download achterzijde als pdf',
  upload_csv_error:
    'Het bestand heeft niet de juiste indeling. Gebruik alstublieft dezelfde indeling als in het voorbeeldbestand!',
  repeat_incentive: 'Voeg dezelfde cadeaus toe voor vrienden',
  dear: 'Beste',
  hello: 'Beste',
  current_month: 'Huidige maand',
  required: 'Verplicht',
  sku_not_exist:
    'Deze SKU-code "{{sku}}" bestaat niet in de geüploade gegevens',
  sku_exist: 'Deze SKU-code "{{sku}}" bestaat al',
  skuCodes_not_match_data_upload:
    'SKU-codes "{{sku}}" bestaan in de geüploade gegevens, maar niet in de geselecteerde incentive-items',
  campaign_has_no_incentives:
    'Deze campagne heeft geen incentives gekoppeld. Open de campagne en koppel ten minste één incentive in de stap Incentives voordat je hem lanceert.',
  gift_group_theme_missing:
    'Deze klant heeft geen cadeauportaal-thema geconfigureerd. Ga naar Instellingen → Thema → Details en stel een slug in voordat je een Cadeaugroep-incentive koppelt.',
  incentive_customer_mismatch:
    'Je kunt geen incentive koppelen die toebehoort aan een andere klant dan de campagne.',
  incentive_customer_missing_intersolve:
    'De geselecteerde klant heeft geen Intersolve-integratie. Voeg er een toe in Instellingen → Integraties voordat je intersolve- of cadeaugroep-incentives aanmaakt.',
  incentive_claimed_frozen_fields:
    'Deze incentive is al geclaimd. Klant, type en Intersolve-winkel kunnen niet meer worden gewijzigd. Naam, prijs, omschrijving, afbeelding en categorie kun je nog wel bewerken.',
  incentive_integration_customer_mismatch:
    'De geselecteerde Intersolve-winkel hoort niet bij deze klant. Kies een winkel uit de winkels van de nieuwe klant.',
  gift_group_child_customer_mismatch:
    'Cadeaugroep-items moeten bij dezelfde klant horen als de bovenliggende incentive.',
  gift_group_child_not_found:
    'Een of meer geselecteerde cadeaugroep-items bestaan niet meer. Vernieuw de pagina en selecteer de items opnieuw.',
  gift_group_child_type_not_allowed:
    'Een cadeaugroep kan alleen Intersolve- of fysieke incentives aanbieden. Haal de andere items uit de selectie.',
  gift_group_child_type_locked:
    'Deze incentive wordt aangeboden in een cadeaugroep, dus het type moet Intersolve of fysiek blijven. Haal hem eerst uit de cadeaugroep.',
  delete_incentive_with_used_voucher_codes:
    'Deze incentive kan niet worden verwijderd omdat hij door een eindgebruiker is geclaimd.',
  failed_to_attach_incentives: 'Kon de incentives niet koppelen.',
  failed_to_execute_campaign: 'Kon de campagne niet uitvoeren.',
  campaigns_on: 'campagnes op',
  delete: 'Verwijder',
  delete_campaign: 'Campagne verwijderen',
  are_you_sure: 'Weet u zeker dat u deze campagne wilt verwijderen?',
  deleting_campaign:
    'Als u de campagne verwijdert, wordt deze uit de lijst en het dashboard verwijderd.',
  multiselect_placeholder: 'Selecteer een optie',
  previous_campaign: 'Vorige campagne',
  day: 'Dag',
  edit: 'Bewerk',
  disable: 'Uitschakelen',
  api_integration,
  next: 'Volgende Scherm',
  save: 'Opslaan',
  mobile_view: 'Mobiele weergave',
  pick_a_date: 'Kies een datum',
  salutation: 'Begroeting (Aanhef)',
  previous_screen: 'Vorige scherm',
  character: 'Nog teken over',
  characters: 'Nog tekens over',
  upload_image: 'Afbeelding toevoegen',
  languages,
  progress_bar,
  campaign_details,
  navigation,
  campaign_list,
  questionnaire,
  validation_messages,
  end_users,
  file_upload,
  optional_question,
  incentives,
  add_incentive,
  compose_creative,
  offline,
  confirmation,
  happiness_check,
  online,
  print_files_download,
  incentive_categories,
  dashboard_labels,
  tooltips,
  flyer,
  campaign_categories,
  campaign_status,
  incentive_errors_modal,
  incentives_store,
  sku_builder,
  email_notification_texts,
  questionnaire_builder,
  end_users_page,
  end_user_list,
  dashboard,
}

export default translation
